import { SVGProps } from "react";

export const EmailImg: React.FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      {...props}
      width="40"
      height="40"
      viewBox="0 0 134 134"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="67" cy="67" r="66.5" fill="#F0F5F9" stroke="#CAD5E0" />
      <path
        d="M35 59.0002L65.816 78.6122C66.168 78.8722 66.584 79.0002 67 79.0002C67.416 79.0002 67.832 78.8722 68.184 78.6122L99 59.0002L68.2 35.4002C67.488 34.8682 66.512 34.8682 65.8 35.4002L35 59.0002Z"
        fill="#64B5F6"
      />
      <path
        d="M87 35H47C44.796 35 43 36.796 43 39V83C43 84.104 43.896 85 45 85H89C90.104 85 91 84.104 91 83V39C91 36.796 89.208 35 87 35Z"
        fill="white"
      />
      <path
        d="M53 47H81C82.104 47 83 46.104 83 45C83 43.896 82.104 43 81 43H53C51.896 43 51 43.896 51 45C51 46.104 51.896 47 53 47Z"
        fill="#CAD5E0"
      />
      <path
        d="M81 51H53C51.896 51 51 51.896 51 53C51 54.104 51.896 55 53 55H81C82.104 55 83 54.104 83 53C83 51.896 82.104 51 81 51Z"
        fill="#CAD5E0"
      />
      <path
        d="M69 59H53C51.896 59 51 59.896 51 61C51 62.104 51.896 63 53 63H69C70.104 63 71 62.104 71 61C71 59.896 70.104 59 69 59Z"
        fill="#CAD5E0"
      />
      <path
        d="M68.184 78.612C67.832 78.872 67.416 79 67 79C66.584 79 66.168 78.872 65.816 78.612L35 59V95C35 97.208 36.792 99 39 99H95C97.208 99 99 97.208 99 95V59L68.184 78.612Z"
        fill="#1E88E5"
      />
      <path
        d="M95 99H39C36.756 99 35 97.244 35 95C35 94.364 35.304 93.764 35.816 93.388L65.816 73.388C66.168 73.128 66.584 73 67 73C67.416 73 67.832 73.128 68.184 73.388L98.184 93.388C98.696 93.764 99 94.364 99 95C99 97.244 97.244 99 95 99Z"
        fill="#2196F3"
      />
    </svg>
  );
};

export const FileImg: React.FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      {...props}
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="w-7.5 h-7.5"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M1.60966 23.6678H30.3903C31.2793 23.6678 32 22.9471 32 22.0582V6.08437C32 5.19539 31.2793 4.47471 30.3903 4.47471H10.5755L9.65499 1.71801C9.43562 1.06114 8.82073 0.618164 8.12819 0.618164H1.60966C0.720676 0.618164 0 1.33884 0 2.22782V22.0582C0 22.9471 0.720676 23.6678 1.60966 23.6678Z"
          fill="#FD8087"
        />
        <path
          d="M20.4134 5.57421C20.2489 6.06703 19.7876 6.39932 19.2681 6.39932H0V22.0578C0 22.9468 0.720676 23.6675 1.60966 23.6675H30.3903C31.2793 23.6675 32 22.9468 32 22.0578V6.08402C32 5.19504 31.2793 4.47437 30.3903 4.47437H21.9402C21.2477 4.47437 20.6328 4.91734 20.4134 5.57421Z"
          fill="#FE646F"
        />
        <path
          d="M29.7465 27.524H1.60966C0.720676 27.524 0 26.8033 0 25.9144V9.94057C0 9.05159 0.720676 8.33091 1.60966 8.33091H21.4245L22.345 5.57421C22.5644 4.91734 23.1793 4.47437 23.8718 4.47437H29.7465C30.6355 4.47437 31.3561 5.19504 31.3561 6.08402V25.9144C31.3561 26.8033 30.6355 27.524 29.7465 27.524Z"
          fill="#8AC9FE"
        />
        <path
          d="M32 25.9144C32 26.8033 31.2793 27.524 30.3903 27.524H28.4588H1.60966C0.720676 27.524 0 26.8033 0 25.9144V10.2559H28.4588C29.3477 10.2559 30.0684 9.53519 30.0684 8.64621V6.08402C30.0684 5.19504 29.3477 4.47437 28.4588 4.47437H30.3903C31.2793 4.47437 32 5.19504 32 6.08402V25.9144Z"
          fill="#60B7FF"
        />
        <path
          d="M1.60966 31.3812H29.7465C30.6355 31.3812 31.3561 30.6605 31.3561 29.7715V13.7977C31.3561 12.9088 30.6355 12.1881 29.7465 12.1881H10.5755L9.65499 9.43139C9.43562 8.77452 8.82073 8.33154 8.12819 8.33154H1.60966C0.720676 8.33154 0 9.05222 0 9.9412V29.7715C0 30.6605 0.720676 31.3812 1.60966 31.3812Z"
          fill="#FED402"
        />
        <path
          d="M30.3906 12.1877H28.459C29.348 12.1877 30.0686 12.9084 30.0686 13.7974V29.7712C30.0686 30.6602 29.348 31.3809 28.459 31.3809H30.3906C31.2795 31.3809 32.0002 30.6602 32.0002 29.7712V13.7974C32.0002 12.9084 31.2795 12.1877 30.3906 12.1877Z"
          fill="#FAC600"
        />
        <path
          d="M10.7088 23.6675H3.7132C3.35759 23.6675 3.06934 23.9557 3.06934 24.3113V27.695C3.06934 28.0506 3.35759 28.3388 3.7132 28.3388H10.7088C11.0644 28.3388 11.3526 28.0506 11.3526 27.695V24.3113C11.3526 23.9557 11.0644 23.6675 10.7088 23.6675Z"
          fill="#EFEDEF"
        />
        <path
          d="M9.25126 26.486H5.19286C4.92617 26.486 4.70996 26.2698 4.70996 26.0032C4.70996 25.7365 4.92617 25.5203 5.19286 25.5203H9.2512C9.51789 25.5203 9.7341 25.7365 9.7341 26.0032C9.73416 26.2698 9.51795 26.486 9.25126 26.486Z"
          fill="#B5ADB6"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const BookIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      {...props}
      // viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="w-10 h-10"
    >
      <path
        d="M3.94403 36.0072L0.116442 14.2762C0.0794829 14.0664 0.056444 13.8545 0.0474761 13.6417C-0.00940735 11.178 1.75966 9.04979 4.1923 8.6555L11.5785 7.35205L11.3785 36.0072H3.94403Z"
        fill="#35495E"
      />
      <path
        d="M32.3704 35.0551C32.2424 35.5869 31.8122 35.9927 31.2739 36.0896L9.53595 39.9241C8.1658 40.1633 6.759 39.8009 5.67498 38.9294C4.59095 38.058 3.9347 36.7619 3.87388 35.3724C3.81956 33.0168 5.44131 30.9528 7.74285 30.4482L13.8325 32.1586H13.8256L8.34285 33.131C7.73136 33.2385 7.20027 33.6144 6.8957 34.1555C6.59113 34.6965 6.54515 35.3456 6.77043 35.9241C7.16052 36.8559 8.15123 37.3858 9.14285 37.1931L25.7566 34.262L32.3704 35.0551Z"
        fill="#2C3E50"
      />
      <path
        d="M13.8265 32.1584L8.34379 33.1309C7.7323 33.2383 7.20121 33.6143 6.89664 34.1553C6.59206 34.6963 6.54609 35.3454 6.77137 35.924C7.16145 36.8558 8.15217 37.3857 9.14379 37.1929L25.7576 34.2619L13.8265 32.1584Z"
        fill="#F9EAB0"
      />
      <path
        d="M8.84424 22.8763L12.6767 1.14246C12.8138 0.395396 13.5257 -0.102922 14.2746 0.0238424L35.8449 3.82729C38.2793 4.22189 40.0498 6.35143 39.9932 8.81694C39.9838 9.02878 39.9608 9.2398 39.9242 9.44867L36.0918 31.1825L8.84424 22.8763Z"
        fill="#E64C3C"
      />
      <path
        d="M31.3358 7.22276C31.2953 7.22274 31.255 7.21928 31.2151 7.21241L15.5937 4.45793C15.2412 4.37099 15.0164 4.0256 15.0798 3.66807C15.1431 3.31054 15.4728 3.06334 15.8337 3.10276L31.4544 5.85379C31.8067 5.91551 32.0534 6.23631 32.0225 6.59264C31.9916 6.94897 31.6934 7.22256 31.3358 7.22276Z"
        fill="#3F5C6C"
      />
      <path
        d="M28.0211 10.1375C27.9806 10.1376 27.9402 10.1339 27.9004 10.1265L17.7128 8.33268C17.3463 8.25835 17.1058 7.90541 17.1707 7.53709C17.2356 7.16877 17.5823 6.9193 17.9522 6.97475L28.1404 8.76785C28.4948 8.82773 28.7438 9.14969 28.7126 9.50771C28.6814 9.86573 28.3805 10.1398 28.0211 10.1375Z"
        fill="#3F5C6C"
      />
      <path
        d="M29.4592 13.2179L15.1937 10.6979C14.8185 10.6316 14.4607 10.882 14.3944 11.2572L13.1944 18.0503C13.1281 18.4255 13.3785 18.7833 13.7537 18.8496L28.0192 21.3696C28.3944 21.4359 28.7523 21.1855 28.8185 20.8103L30.0185 14.0172C30.0848 13.642 29.8344 13.2842 29.4592 13.2179Z"
        fill="#ECF0F1"
      />
      <path
        d="M39.9917 8.81317C39.9835 9.02601 39.9604 9.23802 39.9227 9.44765L36.0882 31.1787L30.771 29.558L33.8538 12.0821L34.5848 7.95799L35.3296 3.7373L35.8469 3.82696C38.2784 4.2232 40.0465 6.35017 39.9917 8.81317Z"
        fill="#C03A2B"
      />
      <path
        d="M32.0132 25.558L10.4408 21.758C10.3611 21.7443 10.2803 21.7373 10.1994 21.7373C9.48461 21.7391 8.88963 22.2867 8.82863 22.9989C8.76764 23.7111 9.26084 24.3519 9.96493 24.4752L31.696 28.3028C32.3069 28.4135 32.8364 28.7915 33.1394 29.3334C33.4424 29.8754 33.4872 30.5244 33.2615 31.1028C32.8735 32.0326 31.8843 32.5604 30.896 32.3649L9.24769 28.5511C9.16796 28.5374 9.08721 28.5304 9.00631 28.5304C8.29018 28.5286 7.69182 29.0752 7.62893 29.7886C7.56604 30.5019 8.05954 31.1448 8.76493 31.2683L30.5029 35.0959C31.872 35.3359 33.2782 34.9748 34.3622 34.1046C35.4463 33.2345 36.1031 31.9398 36.1649 30.5511C36.2191 28.0845 34.4482 25.9548 32.0132 25.558Z"
        fill="#802F34"
      />
      <path
        d="M33.2618 31.1032C32.8739 32.0329 31.8846 32.5607 30.8963 32.3652L9.24805 28.5514L9.96529 24.4756L31.6963 28.3032C32.3073 28.4138 32.8367 28.7919 33.1397 29.3338C33.4427 29.8757 33.4875 30.5248 33.2618 31.1032Z"
        fill="#F9EAB0"
      />
    </svg>
  );
};

export const BugIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      {...props}
      width="70"
      height="70"
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="w-10 h-10"
    >
      <circle cx="35" cy="35" r="34.5" fill="#F8FAFC" stroke="#CAD5E0" />
      <path
        d="M32.733 21.9611C32.6245 21.9611 32.5148 21.9314 32.4162 21.8693L29.8889 20.2743C29.1947 19.8362 28.7803 19.0846 28.7803 18.2637V15.5946C28.7803 15.2662 29.0465 15 29.3749 15C29.7033 15 29.9695 15.2663 29.9695 15.5946V18.2637C29.9695 18.6739 30.1766 19.0495 30.5236 19.2685L33.0508 20.8634C33.3286 21.0388 33.4116 21.4059 33.2364 21.6837C33.1234 21.8629 32.9304 21.9611 32.733 21.9611Z"
        fill="#5F6C75"
      />
      <path
        d="M37.2662 21.9611C37.0689 21.9611 36.8758 21.863 36.7627 21.6837C36.5875 21.4059 36.6705 21.0388 36.9483 20.8634L39.4755 19.2685C39.8225 19.0496 40.0296 18.6739 40.0296 18.2637V15.5946C40.0296 15.2662 40.2958 15 40.6243 15C40.9527 15 41.2189 15.2663 41.2189 15.5946V18.2637C41.2189 19.0845 40.8044 19.8362 40.1102 20.2743L37.583 21.8692C37.4845 21.9314 37.3748 21.9611 37.2662 21.9611Z"
        fill="#5F6C75"
      />
      <path
        d="M52.7046 41.2455C53.6937 40.7824 53.9148 39.4736 53.1328 38.7113L50.9568 36.5905C50.1458 35.8001 48.966 35.5426 47.9111 35.9015C47.8082 35.9366 47.6696 36.1769 47.5695 36.2237L46.3564 37.8079L47.0272 38.5001L47.9118 39.3606L48.2263 39.2134C48.581 39.0474 49.001 39.1145 49.2863 39.3829L50.9715 40.9683C51.4378 41.4072 52.1247 41.5169 52.7046 41.2455Z"
        fill="#5F6C75"
      />
      <path
        d="M42.8672 38.2414L44.2032 41.0953L47.9118 39.3591V35.9021C47.8087 35.9372 47.7064 35.976 47.6061 36.023L42.8672 38.2414Z"
        fill="#4E5A61"
      />
      <path
        d="M17.2949 41.2455C16.3058 40.7824 16.0847 39.4736 16.8668 38.7113L19.0427 36.5905C19.8537 35.8001 21.0336 35.5426 22.0884 35.9016C22.1914 35.9367 22.4321 36.7954 22.5322 36.8423L23.027 38.3645L22.6084 38.8022L22.0878 39.3607L21.7733 39.2135C21.4186 39.0475 20.9986 39.1146 20.7133 39.383L19.0281 40.9684C18.5617 41.4072 17.8748 41.517 17.2949 41.2455Z"
        fill="#5F6C75"
      />
      <path
        d="M27.1324 38.2414L22.3935 36.023C22.2933 35.976 22.1909 35.9372 22.0879 35.9021V39.3592L25.7964 41.0953L27.1324 38.2414Z"
        fill="#4E5A61"
      />
      <path
        d="M46.9418 47.1829L47.62 48.1721H47.9778C48.3694 48.1721 48.7214 48.411 48.8659 48.775L50.9538 54.0319C51.1857 54.6158 51.7503 54.999 52.3786 54.999C53.45 54.999 54.1909 53.928 53.8131 52.9254L51.5629 46.9543C51.1245 45.791 50.0114 45.021 48.7682 45.021H47.9121L46.7705 45.4704L46.9418 47.1829Z"
        fill="#5F6C75"
      />
      <path
        d="M23.1603 47.0403L22.38 48.1721H22.0221C21.6305 48.1721 21.2785 48.411 21.134 48.775L19.0461 54.0319C18.8141 54.6158 18.2495 54.999 17.6213 54.999C16.5499 54.999 15.809 53.928 16.1868 52.9254L18.437 46.9543C18.8754 45.791 19.9885 45.021 21.2316 45.021H22.0878L23.4076 45.8605L23.1603 47.0403Z"
        fill="#5F6C75"
      />
      <path
        d="M47.9115 45.021H43.5352V48.1721H47.6193C47.8097 47.3987 47.9115 46.5909 47.9115 45.7597V45.021Z"
        fill="#4E5A61"
      />
      <path
        d="M26.4642 45.021H22.0879V45.7597C22.0879 46.5909 22.1896 47.3988 22.3801 48.1721H26.4642V45.021Z"
        fill="#4E5A61"
      />
      <path
        d="M49.5875 24.0156L48.6134 26.4681C48.4689 26.8321 48.1169 27.071 47.7253 27.071H46.7742L46.1426 28.2192L46.5993 29.5464L47.9087 30.2222H48.5159C49.759 30.2222 50.8721 29.4521 51.3105 28.2889L52.4966 25.1414C52.881 24.1214 52.1272 23.0317 51.0372 23.0317C50.3979 23.0317 49.8234 23.4217 49.5875 24.0156Z"
        fill="#5F6C75"
      />
      <path
        d="M39.8203 30.2177H47.9084C47.8787 29.0309 47.4598 27.9399 46.7741 27.0667H39.8203V30.2177Z"
        fill="#4E5A61"
      />
      <path
        d="M20.4121 24.0156L21.3862 26.4681C21.5307 26.8321 21.8827 27.071 22.2743 27.071H23.2254L23.5406 27.9575L23.0839 28.9851L22.0909 30.2222H21.4838C20.2406 30.2222 19.1275 29.4521 18.6891 28.2889L17.503 25.1414C17.1186 24.1214 17.8724 23.0317 18.9624 23.0317C19.6017 23.0317 20.1762 23.4217 20.4121 24.0156Z"
        fill="#5F6C75"
      />
      <path
        d="M30.1789 27.0706H23.2252C22.5395 27.9438 22.1206 29.0349 22.0908 30.2217H30.1789V27.0706Z"
        fill="#4E5A61"
      />
      <path
        d="M40.4375 27.6011H31.3886L30.5244 24.9645C30.5244 22.0549 31.9343 19.8517 34.8439 19.8517L35.1693 19.6963C38.0789 19.6963 40.4376 22.055 40.4376 24.9646V27.6011H40.4375Z"
        fill="#ACD980"
      />
      <path
        d="M31.3882 27.5987V25.1317C31.3882 22.4399 33.3815 20.1859 35.9496 19.7513C35.6525 19.7011 35.3109 19.6938 34.9994 19.6938C34.9992 19.6938 34.9991 19.6938 34.9989 19.6938H34.8298C31.9202 19.6938 29.5615 22.0525 29.5615 24.9621V27.5987H31.3882Z"
        fill="#8CC951"
      />
      <path
        d="M38.0718 53.8065H31.9295C27.6246 53.8065 25.5779 50.3167 25.5779 46.0118L25.2354 30.2529C25.2354 28.4948 26.8643 27.0696 28.6225 27.0696H42.6833C44.4414 27.0696 45.8667 28.4948 45.8667 30.2529V46.0118C45.8667 50.3167 42.3768 53.8065 38.0718 53.8065Z"
        fill="#7DC03A"
      />
      <path
        d="M26.1353 46.0117V30.2529C26.1353 28.4948 27.5605 27.0696 29.3186 27.0696H27.3171C25.559 27.0696 24.1338 28.4948 24.1338 30.2529V46.0118C24.1338 50.3167 27.6236 53.8066 31.9286 53.8066H33.93C29.6251 53.8065 26.1353 50.3167 26.1353 46.0117Z"
        fill="#6EA734"
      />
      <path
        d="M34.4053 27.0696H35.5946V53.8065H34.4053V27.0696Z"
        fill="#6EA734"
      />
      <path
        d="M41.955 44.5133L35.7543 33.5658L35.32 33.3599C35.1084 32.9862 34.9418 33.7283 34.7301 34.102L28.9834 44.5132C28.7747 44.8816 29.3211 45.3382 29.7446 45.3382H41.474C41.8975 45.3383 42.1636 44.8816 41.955 44.5133Z"
        fill="#F5DE46"
      />
      <path
        d="M29.5545 44.512L35.7552 33.5645L35.4819 33.082C35.2703 32.7083 34.7318 32.7083 34.5202 33.082L28.0462 44.5119C27.8375 44.8804 28.1037 45.3369 28.5271 45.3369H30.0353C29.6119 45.337 29.3458 44.8804 29.5545 44.512Z"
        fill="#ECC52E"
      />
      <path
        d="M35 40.8741C34.6715 40.8741 34.4053 40.6078 34.4053 40.2794V37.6007C34.4053 37.2723 34.6715 37.0061 35 37.0061C35.3284 37.0061 35.5946 37.2724 35.5946 37.6007V40.2794C35.5947 40.6078 35.3284 40.8741 35 40.8741Z"
        fill="#5F6C75"
      />
      <path
        d="M35 43.2486C34.6715 43.2486 34.4053 42.9824 34.4053 42.6539V42.4152C34.4053 42.0867 34.6715 41.8206 35 41.8206C35.3284 41.8206 35.5946 42.0868 35.5946 42.4152V42.6539C35.5947 42.9824 35.3284 43.2486 35 43.2486Z"
        fill="#5F6C75"
      />
    </svg>
  );
};

export const RegistrationIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      {...props}
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.625 11.25H34.375C35.038 11.25 35.6739 11.5134 36.1428 11.9822C36.6116 12.4511 36.875 13.087 36.875 13.75V30H3.125V13.75C3.125 13.087 3.38839 12.4511 3.85723 11.9822C4.32607 11.5134 4.96196 11.25 5.625 11.25V11.25Z"
        fill="#353744"
      />
      <path
        d="M5.625 11.25H31.875C32.538 11.25 33.1739 11.5134 33.6428 11.9822C34.1116 12.4511 34.375 13.087 34.375 13.75V30H3.125V13.75C3.125 13.087 3.38839 12.4511 3.85723 11.9822C4.32607 11.5134 4.96196 11.25 5.625 11.25V11.25Z"
        fill="#55525B"
      />
      <path
        d="M34.375 33.125H5.625C4.96196 33.125 4.32607 32.8616 3.85723 32.3928C3.38839 31.9239 3.125 31.288 3.125 30.625V30H36.875V30.625C36.875 31.288 36.6116 31.9239 36.1428 32.3928C35.6739 32.8616 35.038 33.125 34.375 33.125V33.125Z"
        fill="#85B1CF"
      />
      <path
        d="M3.125 30H34.375V30.625C34.375 31.288 34.1116 31.9239 33.6428 32.3928C33.1739 32.8616 32.538 33.125 31.875 33.125H5.625C4.96196 33.125 4.32607 32.8616 3.85723 32.3928C3.38839 31.9239 3.125 31.288 3.125 30.625V30Z"
        fill="#B6CDDD"
      />
      <path d="M16.25 33.125H21.875V35.625H16.25V33.125Z" fill="#AAC3D7" />
      <path d="M16.25 34.375H20V35.625H16.25V34.375Z" fill="#D7E6E6" />
      <path
        d="M13.75 35.625H23.75C24.0815 35.625 24.3995 35.7567 24.6339 35.9911C24.8683 36.2255 25 36.5435 25 36.875V37.5H12.5V36.875C12.5 36.5435 12.6317 36.2255 12.8661 35.9911C13.1005 35.7567 13.4185 35.625 13.75 35.625V35.625Z"
        fill="#D7E6E6"
      />
      <path
        d="M22.5 35.625H23.75C24.0815 35.625 24.3995 35.7567 24.6339 35.9911C24.8683 36.2255 25 36.5435 25 36.875V37.5H21.25V36.875C21.25 36.5435 21.3817 36.2255 21.6161 35.9911C21.8505 35.7567 22.1685 35.625 22.5 35.625Z"
        fill="#AAC3D7"
      />
      <path
        d="M4.375 27.7366V13.75C4.375 13.4185 4.5067 13.1005 4.74112 12.8661C4.97554 12.6317 5.29348 12.5 5.625 12.5H19.6116C19.7971 12.5 19.9783 12.555 20.1325 12.658C20.2867 12.761 20.4068 12.9074 20.4778 13.0787C20.5488 13.25 20.5673 13.4385 20.5312 13.6204C20.495 13.8022 20.4057 13.9693 20.2746 14.1004L5.97539 28.3996C5.84427 28.5307 5.67722 28.62 5.49537 28.6562C5.31351 28.6923 5.12501 28.6738 4.9537 28.6028C4.7824 28.5318 4.63599 28.4117 4.53298 28.2575C4.42997 28.1033 4.37499 27.9221 4.375 27.7366V27.7366Z"
        fill="#737079"
      />
      <path
        d="M27.5 15.625H11.25C9.86929 15.625 8.75 16.7443 8.75 18.125V23.125C8.75 24.5057 9.86929 25.625 11.25 25.625H27.5C28.8807 25.625 30 24.5057 30 23.125V18.125C30 16.7443 28.8807 15.625 27.5 15.625Z"
        fill="#F5871E"
      />
      <path
        d="M25 15.625H11.25C9.86929 15.625 8.75 16.7443 8.75 18.125V23.125C8.75 24.5057 9.86929 25.625 11.25 25.625H25C26.3807 25.625 27.5 24.5057 27.5 23.125V18.125C27.5 16.7443 26.3807 15.625 25 15.625Z"
        fill="#FABE19"
      />
      <path
        d="M13.8465 20.553C14.2814 20.429 14.6567 20.152 14.9034 19.773C15.1501 19.3941 15.2516 18.9388 15.1891 18.491C15.1267 18.0431 14.9045 17.633 14.5635 17.336C14.2225 17.0391 13.7857 16.8753 13.3335 16.875H11.4585C11.2927 16.875 11.1338 16.9408 11.0166 17.0581C10.8993 17.1753 10.8335 17.3342 10.8335 17.5V23.75C10.8335 23.9158 10.8993 24.0747 11.0166 24.1919C11.1338 24.3092 11.2927 24.375 11.4585 24.375C11.6243 24.375 11.7832 24.3092 11.9004 24.1919C12.0176 24.0747 12.0835 23.9158 12.0835 23.75V20.625H12.5106L14.0123 24.0038C14.0797 24.1553 14.2044 24.2738 14.3591 24.3333C14.5139 24.3928 14.6859 24.3884 14.8374 24.3211C14.9888 24.2537 15.1074 24.129 15.1668 23.9742C15.2263 23.8195 15.2219 23.6475 15.1546 23.496L13.8465 20.553ZM12.0835 18.125H13.3335C13.4993 18.125 13.6582 18.1908 13.7754 18.3081C13.8926 18.4253 13.9585 18.5842 13.9585 18.75C13.9585 18.9158 13.8926 19.0747 13.7754 19.1919C13.6582 19.3092 13.4993 19.375 13.3335 19.375H12.0835V18.125Z"
        fill="#F68820"
      />
      <path
        d="M19.7918 18.125C19.9575 18.125 20.1165 18.0592 20.2337 17.9419C20.3509 17.8247 20.4168 17.6658 20.4168 17.5C20.4168 17.3342 20.3509 17.1753 20.2337 17.0581C20.1165 16.9408 19.9575 16.875 19.7918 16.875H16.6667C16.501 16.875 16.342 16.9408 16.2248 17.0581C16.1076 17.1753 16.0417 17.3342 16.0417 17.5V23.75C16.0417 23.9158 16.1076 24.0747 16.2248 24.1919C16.342 24.3092 16.501 24.375 16.6667 24.375H19.7918C19.9575 24.375 20.1165 24.3092 20.2337 24.1919C20.3509 24.0747 20.4168 23.9158 20.4168 23.75C20.4168 23.5842 20.3509 23.4253 20.2337 23.3081C20.1165 23.1908 19.9575 23.125 19.7918 23.125H17.2918V20.625H18.5418C18.7075 20.625 18.8665 20.5592 18.9837 20.4419C19.1009 20.3247 19.1668 20.1658 19.1668 20C19.1668 19.8342 19.1009 19.6753 18.9837 19.5581C18.8665 19.4408 18.7075 19.375 18.5418 19.375H17.2918V18.125H19.7918Z"
        fill="#F68820"
      />
      <path
        d="M24.5835 20.625H23.3335C23.1677 20.625 23.0088 20.6908 22.8916 20.8081C22.7743 20.9253 22.7085 21.0842 22.7085 21.25C22.7085 21.4158 22.7743 21.5747 22.8916 21.6919C23.0088 21.8092 23.1677 21.875 23.3335 21.875H23.9585V22.5C23.9583 22.6657 23.8924 22.8246 23.7752 22.9417C23.6581 23.0589 23.4992 23.1248 23.3335 23.125H22.7085C22.5428 23.1248 22.3839 23.0589 22.2668 22.9417C22.1496 22.8246 22.0837 22.6657 22.0835 22.5V18.75C22.0837 18.5843 22.1496 18.4254 22.2668 18.3083C22.3839 18.1911 22.5428 18.1252 22.7085 18.125H23.3335C23.4992 18.1252 23.6581 18.1911 23.7752 18.3083C23.8924 18.4254 23.9583 18.5843 23.9585 18.75C23.9585 18.9158 24.0243 19.0747 24.1416 19.1919C24.2588 19.3092 24.4177 19.375 24.5835 19.375C24.7493 19.375 24.9082 19.3092 25.0254 19.1919C25.1426 19.0747 25.2085 18.9158 25.2085 18.75C25.2079 18.2529 25.0102 17.7763 24.6587 17.4248C24.3072 17.0733 23.8306 16.8756 23.3335 16.875H22.7085C22.2114 16.8756 21.7348 17.0733 21.3833 17.4248C21.0318 17.7763 20.8341 18.2529 20.8335 18.75V22.5C20.8341 22.9971 21.0318 23.4737 21.3833 23.8252C21.7348 24.1767 22.2114 24.3744 22.7085 24.375H23.3335C23.8306 24.3744 24.3072 24.1767 24.6587 23.8252C25.0102 23.4737 25.2079 22.9971 25.2085 22.5V21.25C25.2085 21.0842 25.1426 20.9253 25.0254 20.8081C24.9082 20.6908 24.7493 20.625 24.5835 20.625Z"
        fill="#F68820"
      />
      <path
        d="M32.5 3.75H6.25C5.55964 3.75 5 4.30964 5 5C5 5.69036 5.55964 6.25 6.25 6.25H32.5C33.1904 6.25 33.75 5.69036 33.75 5C33.75 4.30964 33.1904 3.75 32.5 3.75Z"
        fill="#353744"
      />
      <path
        d="M18.125 3.75H6.25C5.55964 3.75 5 4.30964 5 5C5 5.69036 5.55964 6.25 6.25 6.25H18.125C18.8154 6.25 19.375 5.69036 19.375 5C19.375 4.30964 18.8154 3.75 18.125 3.75Z"
        fill="#55525B"
      />
      <path d="M10 6.25H28.75V11.25H10V6.25Z" fill="#353744" />
      <path d="M10 7.5H19.375V11.25H10V7.5Z" fill="#55525B" />
      <path d="M31.25 3.75H32.5V10.625H31.25V3.75Z" fill="#F5871E" />
      <path d="M31.25 10.625H32.5V11.25H31.25V10.625Z" fill="#D7E6F0" />
      <path
        d="M31.25 11.25H32.5C32.6658 11.25 32.8247 11.3158 32.9419 11.4331C33.0592 11.5503 33.125 11.7092 33.125 11.875V15.3125C33.125 15.3954 33.0921 15.4749 33.0335 15.5335C32.9749 15.5921 32.8954 15.625 32.8125 15.625H30.9375C30.8546 15.625 30.7751 15.5921 30.7165 15.5335C30.6579 15.4749 30.625 15.3954 30.625 15.3125V11.875C30.625 11.7092 30.6908 11.5503 30.8081 11.4331C30.9253 11.3158 31.0842 11.25 31.25 11.25Z"
        fill="#FABE19"
      />
      <path
        d="M32.1875 11.875H33.125V15.3125C33.125 15.3954 33.0921 15.4749 33.0335 15.5335C32.9749 15.5921 32.8954 15.625 32.8125 15.625H31.875V12.1875C31.875 12.1046 31.9079 12.0251 31.9665 11.9665C32.0251 11.9079 32.1046 11.875 32.1875 11.875Z"
        fill="#F5871E"
      />
    </svg>
  );
};

export const LogoBlue: React.FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      {...props}
      width="168"
      height="36"
      viewBox="0 0 168 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.3013 21.8919C19.3013 21.5354 19.1659 21.2064 18.8951 20.9596C18.6243 20.7128 18.2994 20.5757 17.9744 20.5757H17.8932C17.5141 20.6306 17.1621 20.8225 16.8913 21.0967C16.1331 21.837 15.2124 22.4403 14.2375 22.7967C13.2897 23.1532 12.2878 23.3177 11.2859 23.3451C9.66112 23.3451 8.36132 22.8516 7.35939 21.837C6.35746 20.8225 5.81587 19.4516 5.84295 18.0257V17.9983V17.9709C5.84295 16.5451 6.33038 15.1741 7.22399 14.1048C8.11761 13.008 9.41741 12.4596 11.2317 12.4596C12.6398 12.4596 13.7772 12.7612 14.5895 13.3645C15.3478 13.9128 15.7539 14.4612 15.8081 15.0096C15.8081 15.3935 15.9435 15.7499 16.1872 16.0241L16.2414 16.079C16.783 16.5999 17.6224 16.5725 18.1369 16.0241L18.1911 15.9419C18.4077 15.6128 18.5431 15.229 18.516 14.8177V11.8016C18.5431 11.3903 18.4348 10.979 18.1911 10.6499L18.1369 10.5951C17.8932 10.3209 17.5141 10.1564 17.135 10.1564C16.7559 10.1564 16.4038 10.3209 16.1601 10.5951L16.106 10.6499C16.0247 10.7322 15.9706 10.8419 15.9435 10.9516C14.6166 10.1016 13.0731 9.66284 11.313 9.66284C8.98414 9.66284 7.03444 10.458 5.49092 12.0209C3.94741 13.5838 3.16211 15.5854 3.16211 17.9435C3.16211 20.2467 3.94741 22.1935 5.43676 23.729C6.9532 25.237 8.9029 26.0048 11.2046 26.0048C11.2317 26.0048 11.2859 26.0048 11.313 26.0048C13.4793 26.0048 15.5644 25.3741 17.3516 24.1677C18.6785 23.2903 19.2742 22.5774 19.2742 21.8645L19.3013 21.8919Z"
        fill="#137ACD"
      />
      <path
        d="M34.492 23.2081L34.4107 23.1533C34.0858 22.9339 33.6796 22.8242 33.3005 22.8517H28.7512V3.98715H22.9291C22.5229 3.95973 22.1438 4.0694 21.7918 4.31618L21.7376 4.37101C21.4669 4.61779 21.3044 4.97424 21.3044 5.35811C21.3044 5.74198 21.4669 6.12585 21.7647 6.37263L21.8189 6.40005C22.1438 6.6194 22.5229 6.7565 22.9291 6.72908H26.0703V22.8517H21.521C21.1419 22.8242 20.7357 22.9339 20.4108 23.1533L20.3295 23.2081C20.3024 23.2355 20.2754 23.263 20.2754 23.263C20.0317 23.5372 19.8963 23.8662 19.9233 24.2226C19.9233 24.5791 20.0858 24.9081 20.3566 25.1549L20.4108 25.2097C20.7357 25.4565 21.1148 25.5662 21.521 25.5388H33.3005C33.3546 25.5388 33.3817 25.5388 33.4359 25.5388C33.7879 25.5388 34.1399 25.4291 34.4378 25.2097L34.492 25.1549C34.519 25.1275 34.519 25.1275 34.5461 25.1001C34.7898 24.8259 34.9252 24.4968 34.9252 24.1404C34.8981 23.7839 34.7627 23.4549 34.492 23.2081Z"
        fill="#137ACD"
      />
      <path
        d="M51.8511 23.2081L51.7699 23.1533C51.445 22.9339 51.0388 22.8242 50.6597 22.8517H49.5765V14.5984C49.5765 13.3371 49.0349 12.213 47.9247 11.2259C46.8686 10.2662 45.3792 9.80005 43.5378 9.80005C42.6171 9.80005 41.3444 10.0194 39.6113 10.513C38.0137 10.9242 37.6887 11.171 37.4992 11.363C37.2554 11.6097 37.12 11.9388 37.12 12.2952C37.12 12.6517 37.2554 13.0081 37.4721 13.2275C37.7158 13.5017 38.0678 13.6662 38.4199 13.6388H38.5011C38.7719 13.6113 39.0427 13.5291 39.2864 13.4468C41.0736 12.871 42.4817 12.5694 43.4566 12.5694C44.6481 12.5694 45.5417 12.7888 46.0833 13.2549L46.1103 13.2823C46.5436 13.5839 46.8144 14.1049 46.8415 14.6259V15.9968C46.2999 15.8871 45.7583 15.8323 45.2709 15.7775C44.5939 15.6952 43.8899 15.6678 43.1858 15.6404C40.7487 15.6404 38.8531 16.1888 37.5533 17.2581C36.1994 18.3823 35.5224 19.6984 35.5224 21.2065C35.4953 22.5775 36.091 23.8662 37.093 24.7436C38.122 25.6758 39.5301 26.142 41.2902 26.142C43.24 26.142 45.1084 25.5388 46.8415 24.3597V25.621H50.6326C51.0388 25.6484 51.445 25.5388 51.7699 25.292L51.8782 25.1823C52.3927 24.5791 52.3927 23.7291 51.8511 23.2081ZM38.9344 22.6871C38.474 22.3033 38.2303 21.7549 38.2303 21.1517C38.2303 20.4936 38.5552 19.9178 39.2051 19.4242C40.18 18.6565 41.5881 18.2726 43.3753 18.3C44.0794 18.3 44.7835 18.3549 45.4604 18.4371C45.9208 18.492 46.4082 18.5742 46.8415 18.6839V20.85C46.0562 21.6178 45.1355 22.2484 44.1877 22.742C43.267 23.1533 42.2651 23.3726 41.2361 23.3726C40.2071 23.3452 39.4489 23.1258 38.9344 22.6871Z"
        fill="#137ACD"
      />
      <path
        d="M72.8089 23.2081L72.7277 23.1532C72.4028 22.9339 72.0236 22.8242 71.6175 22.8516H71.1842V14.0774C71.1571 12.871 70.6968 11.7742 69.8844 10.9516C69.1532 10.1565 68.1242 9.74518 67.0681 9.80002C66.2829 9.80002 65.5246 10.0468 64.8747 10.4581C64.3873 10.7597 63.954 11.1436 63.5479 11.5274C63.2771 11.1162 62.925 10.7597 62.5459 10.4855L62.5188 10.4581C61.8689 9.99196 61.1107 9.7726 60.3254 9.80002C59.4047 9.80002 58.484 10.1291 57.5904 10.7871V10.2662H54.4763C54.0701 10.2387 53.691 10.3484 53.3661 10.5952L53.3119 10.6226C53.0411 10.8694 52.8786 11.2258 52.8786 11.6097C52.8786 11.9936 53.014 12.35 53.3119 12.6242L53.3661 12.6791C53.691 12.9258 54.0701 13.0355 54.4763 13.0081H54.9096V22.8516H54.4763C54.0972 22.8242 53.691 22.9339 53.3661 23.1532L53.2848 23.2081C53.2578 23.2355 53.2577 23.2355 53.2307 23.2629C52.987 23.5371 52.8516 23.8661 52.8516 24.2226C52.8516 24.5791 53.014 24.9355 53.2578 25.1823L53.3119 25.2371C53.6369 25.4839 54.016 25.5936 54.4222 25.5661H58.0237C58.4299 25.5936 58.809 25.4839 59.1339 25.2371L59.1881 25.1823C59.2152 25.1549 59.2423 25.1274 59.2423 25.1274C59.7568 24.5791 59.7297 23.7291 59.1881 23.2081L59.1069 23.1532C58.7819 22.9339 58.4028 22.8242 57.9966 22.8516H57.5633V14.7903C58.1862 13.8855 58.7548 13.2274 59.2964 12.871C59.5943 12.6516 59.9463 12.542 60.3254 12.5145C60.6775 12.5145 61.0024 12.6791 61.219 12.9532L61.2461 12.9807C61.5711 13.3371 61.7335 13.8033 61.7065 14.2968V25.5661H64.8206C64.8477 25.5661 64.9018 25.5661 64.9289 25.5661C65.2809 25.5661 65.633 25.4565 65.9308 25.2371L65.985 25.1823C66.0121 25.1549 66.0391 25.1274 66.0391 25.1274C66.5536 24.5791 66.5266 23.7291 65.985 23.2081L65.9037 23.1532C65.5788 22.9339 65.1997 22.8242 64.7935 22.8516H64.3873V14.7629C65.1184 13.6113 65.633 13.1452 65.9308 12.9258L65.9579 12.8984C66.2829 12.6516 66.689 12.5145 67.1223 12.4871C67.4743 12.4871 67.7993 12.6516 68.043 12.9532C68.3409 13.2823 68.5034 13.721 68.4763 14.1871V25.5661H71.5904C71.9966 25.5936 72.3757 25.4839 72.7006 25.2371L72.7548 25.1823C72.7819 25.1549 72.7819 25.1549 72.8089 25.1274C73.3505 24.5791 73.3235 23.7291 72.8089 23.2081Z"
        fill="#137ACD"
      />
      <path
        d="M91.1434 13.6662C90.4935 12.4597 89.4916 11.4452 88.3001 10.7871C87.0815 10.1016 85.7005 9.7452 84.3465 9.77262C83.1279 9.7452 81.8823 10.0194 80.7721 10.5952C80.2034 10.8968 79.6889 11.2807 79.2285 11.692V10.2387H75.4374C75.0313 10.2113 74.6522 10.321 74.3272 10.5678L74.273 10.5952C74.0023 10.842 73.8398 11.1984 73.8398 11.5823C73.8398 11.9662 74.0023 12.3226 74.273 12.5968L74.3272 12.6517C74.6522 12.8984 75.0313 13.0081 75.4374 12.9807H76.5206V29.0484H75.4374C75.0583 29.021 74.6522 29.1307 74.3272 29.35L74.246 29.4049C74.2189 29.4323 74.2189 29.4323 74.1918 29.4597C73.6773 30.0081 73.7044 30.8581 74.246 31.3791L74.3272 31.4339C74.6251 31.6533 74.95 31.7629 75.302 31.7629C75.3291 31.7629 75.3833 31.7629 75.4104 31.7629H81.7198C82.126 31.7904 82.5051 31.6807 82.8301 31.4339L82.8842 31.4065C83.155 31.1597 83.3175 30.8033 83.3175 30.4194C83.3446 30.0355 83.1821 29.6516 82.9113 29.4049L82.8301 29.35C82.5051 29.1307 82.126 29.021 81.7198 29.0484H79.1744V23.3452C80.5825 24.6065 82.3156 25.2371 84.2923 25.2371C86.3504 25.292 88.3813 24.4694 89.8436 22.9887C91.3059 21.5629 92.1453 19.5613 92.1182 17.5049C92.1453 16.1613 91.7933 14.8178 91.1434 13.6662ZM89.4374 17.4775C89.4645 18.821 88.9229 20.0823 87.948 20.9871C85.9171 22.9613 82.7218 22.9613 80.6908 20.9871C80.6367 20.9323 80.6096 20.9049 80.5554 20.85C79.6618 19.9178 79.2015 18.6839 79.2285 17.3952C79.2556 16.1065 79.7701 14.9 80.6908 13.9952C81.7198 13.0081 83.0196 12.5146 84.3194 12.5146C85.6192 12.5146 86.9461 13.0081 87.9751 13.9952C88.9229 14.8726 89.4645 16.1613 89.4374 17.4775Z"
        fill="#137ACD"
      />
      <path
        d="M110.396 23.2081L110.315 23.1258C109.99 22.879 109.583 22.7693 109.204 22.8242H108.392V15.1193C108.392 14.1322 108.094 13.1451 107.553 12.35C107.038 11.5274 106.334 10.8419 105.467 10.4032H105.44C104.52 9.96449 103.518 9.77256 102.489 9.79997C101.487 9.79997 100.485 10.0193 99.5913 10.4306L99.5642 10.458C99.0497 10.7322 98.5623 11.0613 98.129 11.4177V4.01449H94.3379C93.9317 3.98707 93.5526 4.09675 93.2277 4.34352L93.1735 4.39836C92.9027 4.64514 92.7402 5.00159 92.7402 5.38546C92.7402 5.76933 92.8756 6.12578 93.1735 6.39997L93.2277 6.45482C93.5526 6.70159 93.9317 6.81126 94.3379 6.78384H95.4211V22.9064H94.6087C94.2296 22.879 93.8234 22.9887 93.4984 23.2081L93.3631 23.3177C92.8485 23.8661 92.8756 24.7161 93.4172 25.2371L93.4714 25.2919C93.7692 25.5113 94.1213 25.621 94.4733 25.621C94.5004 25.621 94.5545 25.621 94.5816 25.621H98.8872C99.2934 25.6484 99.6725 25.5387 99.9975 25.2919L100.052 25.2371C100.079 25.2097 100.106 25.2097 100.106 25.1822C100.62 24.6339 100.593 23.7839 100.052 23.2629L99.9704 23.2081C99.6454 22.9887 99.2663 22.879 98.8601 22.9064H98.0477V15.2838C99.2934 13.8855 99.9162 13.3645 100.214 13.1451C100.837 12.7339 101.568 12.5145 102.326 12.5419C103.409 12.5419 104.195 12.8161 104.763 13.3371C105.305 13.8306 105.603 14.5161 105.576 15.2838V22.879H104.79C104.384 22.8516 104.005 22.9613 103.68 23.1806L103.599 23.2355C103.572 23.2629 103.572 23.2629 103.545 23.2903C103.03 23.8387 103.057 24.6887 103.599 25.2097L103.653 25.2645C103.978 25.5113 104.384 25.621 104.79 25.5935H109.204C109.611 25.621 110.017 25.5113 110.342 25.2645L110.423 25.2097C110.91 24.6064 110.91 23.7564 110.396 23.2081Z"
        fill="#137ACD"
      />
      <path
        d="M164.473 23.2081L164.392 23.1533C164.067 22.9339 163.66 22.8242 163.281 22.8517H162.063L156.187 16.7646L160.655 12.9807H161.927C162.334 13.0081 162.74 12.8984 163.065 12.6517L163.119 12.5968C163.39 12.3501 163.552 11.9936 163.552 11.6097C163.552 11.2259 163.417 10.8694 163.119 10.5952L163.065 10.5404C162.74 10.2936 162.334 10.1839 161.927 10.2113H157.676C157.27 10.1839 156.891 10.2936 156.566 10.5404L156.512 10.5952C156.241 10.842 156.078 11.2259 156.078 11.6097C156.078 11.9936 156.241 12.3501 156.512 12.5968L156.566 12.6517C156.62 12.6791 156.674 12.7339 156.728 12.7613L153.316 15.6678V3.98715H149.525C149.119 3.95973 148.74 4.0694 148.415 4.31618L148.361 4.37101C148.09 4.61779 147.927 4.97424 147.927 5.35811C147.927 5.74198 148.063 6.09843 148.361 6.37263L148.415 6.42747C148.74 6.67424 149.146 6.78392 149.525 6.7565H150.608V22.8791H149.525C149.146 22.8517 148.74 22.9613 148.415 23.1807L148.334 23.2355C148.307 23.263 148.307 23.263 148.279 23.2904C148.036 23.5646 147.9 23.8936 147.9 24.2501C147.9 24.6065 148.063 24.963 148.307 25.2097L148.361 25.2646C148.659 25.4839 149.011 25.5936 149.363 25.5936C149.39 25.5936 149.444 25.5936 149.471 25.5936H153.262V19.1775L154.047 18.492L158.299 22.9065C158.136 22.9613 157.974 23.0436 157.811 23.1533L157.73 23.2081C157.703 23.2355 157.676 23.2355 157.676 23.263C157.432 23.5372 157.297 23.8662 157.324 24.2226C157.351 24.5791 157.486 24.9081 157.757 25.1549L157.811 25.2097C158.136 25.4565 158.543 25.5662 158.922 25.5388H163.2C163.606 25.5662 164.013 25.4565 164.337 25.2097L164.392 25.1549C164.419 25.1275 164.419 25.1275 164.446 25.1001C165.014 24.5791 165.014 23.7291 164.473 23.2081Z"
        fill="#137ACD"
      />
      <path
        d="M124.911 19.0129H127.267C126.671 23.4274 122.637 26.4984 118.304 25.8951C114.757 25.4016 111.994 22.5774 111.507 19.0129C111.399 18.2726 111.399 17.5597 111.507 16.8193C112.103 12.4048 116.138 9.33384 120.47 9.93707C124.018 10.4306 126.78 13.2548 127.267 16.8193H124.911C124.315 13.7209 121.364 11.7193 118.304 12.3226C116.056 12.7613 114.296 14.5435 113.863 16.8193C113.728 17.5322 113.728 18.3 113.863 19.0129C114.459 22.1113 117.41 24.1129 120.47 23.5096C122.718 23.0709 124.478 21.2887 124.911 19.0129Z"
        fill="#137ACD"
      />
      <path
        d="M122.393 17.9161C122.393 18.3 122.311 18.6565 122.176 19.0129C121.58 20.5758 119.874 21.3436 118.331 20.7677C117.545 20.4661 116.923 19.8355 116.598 19.0129C116.327 18.3 116.327 17.5323 116.598 16.8194C117.193 15.2565 118.899 14.4887 120.443 15.0645C121.228 15.3661 121.851 15.9968 122.176 16.8194C122.311 17.1758 122.393 17.5597 122.393 17.9161Z"
        fill="#137ACD"
      />
      <path
        d="M147.035 17.9161C147.035 18.2726 147.008 18.6564 146.953 19.0129C146.358 23.4274 142.323 26.4984 137.99 25.8951C134.443 25.4016 131.681 22.5774 131.193 19.0129H133.549C134.145 22.1113 137.097 24.1129 140.157 23.5096C142.404 23.0709 144.164 21.2887 144.598 19.0129C144.733 18.3 144.733 17.5322 144.598 16.8193C144.002 13.7209 141.05 11.7193 137.99 12.3226C135.743 12.7613 133.983 14.5435 133.549 16.8193H131.193C131.789 12.4048 135.824 9.33384 140.157 9.93707C143.704 10.4306 146.466 13.2548 146.953 16.8193C147.008 17.2032 147.035 17.5597 147.035 17.9161Z"
        fill="#137ACD"
      />
      <path
        d="M142.051 17.9161C142.051 18.3 141.97 18.6565 141.834 19.0129C141.238 20.5758 139.532 21.3436 137.989 20.7677C137.204 20.4661 136.581 19.8355 136.256 19.0129C135.985 18.3 135.985 17.5323 136.256 16.8194C136.852 15.2565 138.558 14.4887 140.101 15.0645C140.886 15.3661 141.509 15.9968 141.834 16.8194C141.997 17.1758 142.051 17.5597 142.051 17.9161Z"
        fill="#137ACD"
      />
    </svg>
  );
};

export const UserAvatar: React.FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M43.9751 47.965L42.9751 43.965C42.5006 42.0245 41.0622 40.464 39.1667 39.8334L31.8333 37.39C30.045 36.645 29.2267 33.765 29.05 32.6716C30.4126 31.5385 31.2894 29.9263 31.5 28.1666C31.4699 27.8661 31.5408 27.5641 31.7016 27.3083C31.9615 27.2432 32.1742 27.0571 32.2733 26.8083C32.7531 25.6464 33.0543 24.4186 33.1666 23.1666C33.1669 23.0986 33.1585 23.0309 33.1416 22.965C33.0222 22.4785 32.7362 22.0492 32.3333 21.7516V17.3333C32.3333 14.6483 31.5133 13.5466 30.6499 12.9083C30.4851 11.615 29.1001 9 24.0001 9C19.4753 9.18219 15.8489 12.8086 15.6667 17.3334V21.7517C15.2637 22.0493 14.9777 22.4786 14.8583 22.9651C14.8415 23.0309 14.8331 23.0988 14.8333 23.1667C14.9455 24.4193 15.2467 25.6477 15.7267 26.8101C15.7989 27.0456 15.9882 27.2268 16.2267 27.2884C16.3201 27.3351 16.4951 27.5768 16.4951 28.1668C16.7069 29.9315 17.5887 31.5473 18.9584 32.6802C18.7834 33.7718 17.9701 36.6502 16.2318 37.3768L8.83342 39.8334C6.93944 40.464 5.50193 42.023 5.02678 43.9618L4.02678 47.9618C3.91358 48.4079 4.18342 48.8613 4.62951 48.9745C4.69615 48.9915 4.76467 49.0001 4.83342 49.0002H43.1668C43.627 49 44 48.6268 43.9999 48.1666C43.9998 48.0985 43.9915 48.0309 43.9751 47.965Z"
        fill="current"
      />
    </svg>
  );
};

export const HeroIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg fill="none" viewBox="0 0 455 561" {...props}>
      <path
        fill="#B3737B"
        d="M266 407.4l-2.8 7.4-12.5 34a29.9 29.9 0 01-17.3 5.5l-2.5-.2c-7-.5-13.7-3.5-18.3-7.4l3.8-41.1.2-3a97.7 97.7 0 0049.3 4.8z"
      />
      <path
        fill="#73325A"
        d="M266 407.4l-5.4 14.4c-16.2 2.2-39.9-11-44.2-16.2l.3-3a97.6 97.6 0 0049.2 4.8z"
      />
      <path
        fill="#fff"
        stroke="#89BDE6"
        d="M251 448.8L247 489c-.7 10.5-8.8 18.6-18.4 18.6h-1.3c-10.2-.8-17.9-10.4-17.2-21.5l2.4-35.4.2-3.8a28.6 28.6 0 007 4.8 30.6 30.6 0 0011 3 30 30 0 009-.6h.3a27.7 27.7 0 0010.9-5.3z"
      />
      <path
        stroke="#89BDE6"
        d="M247.3 451.3l-2.7 32c-.6 9-7.5 15.9-15.6 15.9h-1.1c-8.6-.7-15.1-8.9-14.5-18.2l2.1-32"
      />
      <path
        fill="#89BDE6"
        d="M240 453.7a34.9 34.9 0 01-9.1.4c-4-.3-7.7-1.2-11-2.7l-1-5.2c-.7-2.2 1-4.5 3.3-4.4l15.4.5a3.4 3.4 0 013.2 3.7l-.8 7.7z"
      />
      <path
        fill="#89BDE6"
        d="M239.9 453.5l-2 24.4c-.3 4.7-4.8 8.2-9 7.4h-.4c-6-1.1-10.6-7.4-9.8-14.1l1.2-19.8a32.6 32.6 0 0011 2.7h2.4a32 32 0 006.6-.6z"
      />
      <path
        stroke="#fff"
        d="M237.5 480l-17.5-4.1c-1.8-.4-1.7-3 .1-3.2l16.8-2c2-.2 2.3-3 .4-3.6l-16.1-5.1c-2.5-.8-2.3-4.3.3-4.8l18.4-3.2s-13.8 1.2-20-2.3"
      />
      <path
        fill="#0F62A4"
        d="M299 317.3l-33 90.1c-5.6 1.7-31.9 4-57.5-8l20.2-93.1a28.4 28.4 0 0128.1-24.7h14.8a28.4 28.4 0 0127.5 35.7z"
      />
      <path stroke="#fff" d="M269.8 397.8c-5.6 1.7-34 3.8-59.7-8.1" />
      <path
        fill="#B3737B"
        d="M310.1 409.2l-3.3 6-21.4 37.2c-8.2 3.3-17.9 4.5-26.6 2.7l-1-.3c-4.4-1-8.8-3.3-11.9-6l15.6-41.6a99.8 99.8 0 0048.6 2z"
      />
      <path
        fill="#73325A"
        d="M310.1 409.2l-7 12.4c-27.1 4.3-42.5-12-42.5-12l1-2.4c5.3 1.8 23.8 6.8 48.5 2z"
      />
      <path
        fill="#0F62A4"
        d="M355.8 331.6l-37 75.9c-31.2 7.8-52 1.5-57.3-.3l38.7-103.4a33.8 33.8 0 0112.5-15 33.8 33.8 0 0118.7-5.7c25.8 0 36.9 25.9 24.4 48.5z"
      />
      <path
        stroke="#fff"
        d="M323 399.3a104.7 104.7 0 01-58-.3M300.2 303.8L243.3 457"
      />
      <path
        fill="#fff"
        stroke="#89BDE6"
        d="M285.1 452.6l-1.2 3.2-14.2 37.1c-4 12.7-17.4 20.3-29.1 17.4l-.7-.2c-8.2-2-13.4-12-10.2-20.7l16.2-39.6.3-.8a24.6 24.6 0 007 4.4 26.7 26.7 0 004.5 1.4l1.1.3c4.6 1 9.4 1.1 14 .6a48.9 48.9 0 0012.3-3.1z"
      />
      <path
        stroke="#89BDE6"
        d="M280.5 454.3L268.1 487c-3.4 10.6-14.6 17-24.4 14.5l-.5-.1c-7-1.8-11.3-10-8.6-17.4l13.7-33.3"
      />
      <path
        fill="#89BDE6"
        d="M275.8 450.7l-3 5a44 44 0 01-14-.6l-1-.3a24 24 0 01-4.5-1.4l1.1-8c.3-2 2.2-3.3 4-2.9l15.1 3.2c2.3.5 3.5 3 2.3 5z"
      />
      <path
        fill="#89BDE6"
        d="M272.9 455.7h-.1l-7.6 20c-2 6.5-8.8 10.3-14.8 8.8l-.3-.1c-4.2-1-6.8-6-5.2-10.5l8.3-20.2v-.3a26.6 26.6 0 004.5 1.4l1.1.3c4.6 1 9.4 1.1 14 .6z"
      />
      <path
        stroke="#fff"
        d="M244.4 477.4l17.4 1.9c2 .2 3-2.7 1.1-3.7l-13.5-7.2c-1.8-1-1-3.7 1-3.6l17 .7c2.3.1 3.2-3 1.2-4l-15.3-8.1s7.8 3.7 19.5 2.2"
      />
      <path
        fill="#D0E4F5"
        d="M203.8 286.4a118.2 118.2 0 100-236.5 118.2 118.2 0 000 236.5z"
      />
      <path stroke="#89BDE6" d="M164.2 286.4A124.7 124.7 0 0179 168.2" />
      <path
        stroke="#fff"
        d="M203.8 244.5a76.4 76.4 0 100-152.7 76.4 76.4 0 000 152.7zM203.8 91.9v12.7m0 127.2v12.7m-54-130.3l9 9m90 90l9 9m-130.4-54H140m127.3 0h12.8m-130.5 54l9-9m90-90l9-9"
      />
      <path
        fill="#D0E4F5"
        stroke="#fff"
        d="M203.8 249.3a80.8 80.8 0 01-81.2-81.1c0-22.5 8.7-43.1 24.4-57.4l6.5 7.1a59.7 59.7 0 00-15.5 21.7 73.4 73.4 0 00-.2 56.4 71.5 71.5 0 0015.3 22.8 71 71 0 0078.5 15.3 71.7 71.7 0 0022.8-15.3 71.3 71.3 0 0021-50.6 68.9 68.9 0 00-5.8-27.8 72 72 0 00-15.9-22.8 74.1 74.1 0 00-23.2-15.3c-9-3.8-17-5.3-26.7-5.3v-9.7c11 0 20.2 1.9 30.4 6a83.5 83.5 0 0126.3 17.4 81.5 81.5 0 0124.5 57.5 80.7 80.7 0 01-49.6 74.7 80.6 80.6 0 01-31.6 6.4z"
      />
      <path stroke="#0F62A4" d="M163.7 127.4l50.4 51.7" />
      <path
        fill="#D0E4F5"
        stroke="#fff"
        d="M204.3 172.7a4 4 0 100-8 4 4 0 100 8z"
      />
      <path
        stroke="#fff"
        d="M226.1 83.8l.7-5.1a4 4 0 015-3.2l5 1.5a4 4 0 012.5 5.5l-2.4 4.9"
      />
      <path stroke="#137ACD" d="M191.7 510.9V304.3h187.1V511" />
      <path
        fill="#fff"
        stroke="#137ACD"
        d="M385.4 311.2H185.1a8.2 8.2 0 01-8.2-8.1v-31.3c0-4.5 3.7-8.1 8.2-8.1h200.3c4.5 0 8.2 3.6 8.2 8.1v31.3c0 4.5-3.7 8.1-8.2 8.1z"
      />
      <path
        fill="#137ACD"
        d="M386 305.6H184.5a8.2 8.2 0 01-8.2-8.2v-31.2c0-4.5 3.7-8.2 8.2-8.2H386c4.5 0 8.2 3.7 8.2 8.2v31.2c0 4.6-3.7 8.2-8.2 8.2z"
      />
      <path stroke="#89BDE6" d="M384.7 430.6V406a15.1 15.1 0 0130.2 0v24.5" />
      <path
        fill="#5AA2DC"
        d="M369.7 511H426c6.6 0 11.9-5.3 11.9-11.9v-78.3c0-6.6-5.3-11.9-11.9-11.9h-56.3c-6.5 0-11.9 5.3-11.9 11.9V499c0 6.6 5.4 12 12 12z"
      />
      <path
        stroke="#fff"
        d="M437.9 427.1c0-7.5-6.1-13.6-13.6-13.6h-43.9c-7.5 0-13.6 6.1-13.6 13.6v54.1"
      />
      <path
        fill="#fff"
        stroke="#89BDE6"
        d="M426.2 511h-38.4c-6.5 0-11.7-5.2-11.7-11.7v-69.8c0-6.4 5.2-11.6 11.7-11.6h38.4c6.4 0 11.7 5.2 11.7 11.7v69.7c0 6.5-5.3 11.7-11.7 11.7z"
      />
      <path stroke="#89BDE6" d="M393.1 436v-24.4a15.1 15.1 0 0130.2 0v24.5" />
      <path
        fill="#89BDE6"
        d="M426 501.8h-37.7a5.5 5.5 0 01-5.6-5.5v-28.9a5.5 5.5 0 015.6-5.5h37.8a5.5 5.5 0 015.5 5.5v28.9c0 3-2.5 5.5-5.5 5.5z"
      />
      <path stroke="#89BDE6" d="M369.2 481.2h-4.7" />
      <path
        fill="#fff"
        stroke="#5AA2DC"
        d="M358.6 431c0 23.5-25.6 58.1-16.8 69.2 8.4 10.6 16.8 0 16.8 0v-69.1z"
      />
      <path stroke="#fff" d="M385.8 472.6h42.4" />
      <path stroke="#89BDE6" d="M396.2 435.6H390v3h6v-3zm30 0h-6v3h6v-3z" />
      <path
        stroke="#fff"
        d="M385.8 474.6v-2m3.8 2v-2m3.9 2v-2m3.8 2v-2m3.9 2v-2m3.8 2v-2m4 2v-2m4 2v-2m3.6 2v-2m3.9 2v-2m3.8 2v-2m3.9 2v-2"
      />
      <path
        fill="#fff"
        stroke="#5AA2DC"
        d="M390.2 481.2a1.7 1.7 0 01-1.7-1.9l.9-6.7h1.7l.8 6.7a1.7 1.7 0 01-1.7 2z"
      />
      <path fill="#fff" d="M327.1 258h-71.8v38h71.8v-38z" />
      <path
        fill="#0F62A4"
        stroke="#0F62A4"
        d="M318.7 287.9a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
      />
      <path
        fill="#fff"
        stroke="#0F62A4"
        d="M313.2 287.9a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm-5.5 0a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
      />
      <path
        fill="#0F62A4"
        stroke="#0F62A4"
        d="M318.7 282.3a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
      />
      <path
        fill="#fff"
        stroke="#0F62A4"
        d="M313.2 282.3a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm-5.5 0a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm11-11a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
      />
      <path
        fill="#0F62A4"
        stroke="#0F62A4"
        d="M313.2 271.2a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
      />
      <path
        fill="#fff"
        stroke="#0F62A4"
        d="M307.7 271.2a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm11 5.6a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm-5.5 0a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
      />
      <path
        fill="#0F62A4"
        stroke="#0F62A4"
        d="M307.7 276.8a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm-32.5 0a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
      />
      <path
        fill="#fff"
        stroke="#0F62A4"
        d="M269.7 276.8a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm-5.5-11.1a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm11 5.5a1.5 1.5 0 100-3 1.5 1.5 0 100 3zm-5.5 0a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
      />
      <path
        fill="#0F62A4"
        stroke="#0F62A4"
        d="M264.2 271.2a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
      />
      <path
        fill="#fff"
        stroke="#0F62A4"
        d="M296.1 282.3a1.5 1.5 0 100-3 1.5 1.5 0 100 3zm-5.5 0a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
      />
      <path
        fill="#0F62A4"
        stroke="#0F62A4"
        d="M285 282.3a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm11.1-11a1.5 1.5 0 100-3 1.5 1.5 0 100 3z"
      />
      <path
        fill="#fff"
        stroke="#0F62A4"
        d="M290.6 271.2a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm-5.5 0a1.5 1.5 0 100-3 1.5 1.5 0 100 3zm11 5.6a1.5 1.5 0 100-3 1.5 1.5 0 100 3z"
      />
      <path
        fill="#0F62A4"
        stroke="#0F62A4"
        d="M290.6 276.8a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
      />
      <path
        fill="#fff"
        stroke="#0F62A4"
        d="M285 276.8a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"
      />
      <path
        fill="#fff"
        stroke="#0F62A4"
        d="M375.5 266.7h-74V258H257l-13-38-13.8 25.6 39.2 33.4-18.8 25.4-46.3-29.6a29.6 29.6 0 01-13.4-24.8c0-5 1.2-10 3.7-14.3l21.6-39.1a51.5 51.5 0 0145-26.6h69.5a35.5 35.5 0 0129 15l33.7 46.9a22 22 0 01-17.8 34.8z"
      />
      <path
        fill="#0F62A4"
        d="M265.7 295.7c-5.4 7.4-12.2 11.6-15 9.5-3-2.2-.8-9.9 4.7-17.2 5.4-7.4 11.6-11.3 14.4-9.2 2.9 2.1 1.4 9.5-4 16.9z"
      />
      <path
        stroke="#0F62A4"
        d="M267.2 170l22.2 30.9 20.5-30.8h-42.7zm22.4 42a2.3 2.3 0 100-4.6 2.3 2.3 0 000 4.7zm0 14.8a2.3 2.3 0 10-2.3-2.3 2.3 2.3 0 002.3 2.3zm46.5-8.7l10.6 16.4H302v32.7m44.6-32.7h11.7"
      />
      <path
        fill="#0F62A4"
        d="M302.1 267.2c3.6 0 6.5-7.4 6.5-16.6 0-9.2-3-16.6-6.5-16.6-3.6 0-6.5 7.4-6.5 16.6 0 9.2 3 16.6 6.5 16.6z"
      />
      <path
        stroke="#0F62A4"
        d="M308.5 234.6c3.6 0 6.5 7.1 6.5 16 0 8.8-3 16-6.5 16m-62.8 34.7c-3-2.1-.8-9.8 4.7-17.2 5.5-7.4 11.2-11.3 14.1-9.1"
      />
      <path
        fill="#89BDE6"
        d="M267.3 156.8c.1-15.8 10.6-20.1 27.9-18.7 18.6 1.4 11 27 21.3 27.9 4.3.3 9.3-4.6 15.9-8.6a33.9 33.9 0 0119-5.8 34 34 0 0134 34c0 8.6-4 17-9.4 23 0 0-20-28.2-27.8-30.8-15.3-5.2-20.2 8.2-30.8 10.3a14.5 14.5 0 01-4.5.2c-15.1-1.8-12.2-26.7-12.2-26.7-4-1.6-4.8-5.6-5-8v-2 2c-.3 4.5-3 15.6-18.8 11.6v5.4c0 32.5.5 38.8-6 47-1 1.2-7.6 11 4.1 16.4 15.1 6.8 4.5 24.7 4.5 24.7h-32s-19-3.3-20.6-20.5c-2.4-24.6 28.5-31.2 32.5-32A19 19 0 01244 188c0-8.3 6.4-15.3 13-17.6l.6-.2c5-1.8 8.8-5.7 9.7-10.4l.1-3z"
      />
      <path
        fill="#B3737B"
        d="M295.8 157a.4.4 0 01-.4-.4l.2-8.2c0-.2.1-.4.4-.4.2 0 .4.2.4.4l-.2 8.2c0 .2-.2.4-.4.4zm-18.2 9.3a.4.4 0 01-.2 0c-3.9-2-4.7-4.2-4.8-4.2a.4.4 0 01.3-.5.4.4 0 01.5.2s.8 1.9 4.4 3.8a.4.4 0 01.1.5.4.4 0 01-.3.2z"
      />
      <path
        fill="#89BDE6"
        d="M331.5 152.4a4.8 4.8 0 004.8-4.8 4.8 4.8 0 00-4.8-4.8 4.8 4.8 0 00-4.8 4.8 4.8 4.8 0 004.8 4.8zm-56.7 76a3.9 3.9 0 100-7.7 3.9 3.9 0 00-3.8 3.9 3.9 3.9 0 003.8 3.8z"
      />
      <path
        fill="#B3737B"
        d="M299.2 282.7v3l-.2.6-7 15.7a6.4 6.4 0 01-5.8 3.7h-15a16.8 16.8 0 01-10.4-3.6l-.5-.4-9-7a38.3 38.3 0 0114-15.8h21.6c1.7 3.8-3.9 6.9-3.9 6.9h9.8l3.5-3.8c1-1 2.6-.6 2.9.7z"
      />
      <path
        stroke="#73325A"
        d="M293.6 297.2a6.4 6.4 0 01-5.8 3.7h-12.6m20.6-8.6a6.4 6.4 0 01-5.7 3.7h-12.7m20.8-9.2a6.4 6.4 0 01-5.8 3.7h-12.6"
      />
      <path
        fill="#73325A"
        d="M265.6 295.4a31.3 31.3 0 01-5.3 6.3l-9-7a38.3 38.3 0 0114-15.8h4.6c.4 3.6-.2 9.7-4.3 16.5z"
      />
      <path
        fill="#0F62A4"
        d="M281 246s7.8-20.9 10.8-20.5c3 .4-6.7 18.9-6.7 18.9l-4.1 1.5z"
      />
      <path
        fill="#B3737B"
        d="M308.6 250.6c0 8.9-2.8 16.1-6.2 16.6h-32.1c-1 0-1.7-.8-1.7-1.7v-10.2a6.9 6.9 0 014.4-6.4l13.3-5a10.8 10.8 0 013.8-.7H308c.4 2.2.7 4.7.7 7.4z"
      />
      <path
        stroke="#73325A"
        d="M282.6 251.1l-10 3.8a5.2 5.2 0 00-3.4 4.9m13.4-2.6l-10 3.8a5.2 5.2 0 00-3.4 4.9m12.8-3l-10 3.8"
      />
      <path
        fill="#73325A"
        d="M308.6 250.6c0 8.9-2.7 16.1-6.2 16.6h-.3c-3.6 0-6.5-7.4-6.5-16.6 0-2.5.4-5.3.8-7.4h11.4c.4 2.2.8 5 .8 7.4z"
      />
      <path
        fill="#B3737B"
        d="M306 165.2a4 4 0 01-3.1 4l-2.3.5v2.5c0 6-4.8 10.8-10.8 10.8h-2c-6 0-10.9-4.8-10.9-10.7v-7c15.8 3.9 18.6-7.2 18.9-11.8.1 2.3 1 6.1 4.4 7.9l.6-.2a4.1 4.1 0 015.1 4z"
      />
      <path
        stroke="#73325A"
        d="M292.5 167.2s3.3-.3 5.2 1.3m-17.9-.4s2.4-1.3 5.1-.1c1.6.7 2.7 4.5 2.7 9.5"
      />
      <path
        fill="#73325A"
        d="M283 173c.3 0 .5-.5.5-1.2s-.2-1.2-.6-1.2c-.3 0-.6.5-.6 1.2s.3 1.2.6 1.2zm11.6 0c.3 0 .6-.5.6-1.2s-.3-1.2-.6-1.2c-.4 0-.7.5-.7 1.2s.3 1.2.7 1.2z"
      />
      <path stroke="#73325A" d="M301.3 166.8a3 3 0 012.3-3" />
      <path
        fill="#5AA2DC"
        d="M172.8 413c1.9 4.5 1.3 13.8-8.3 13.6-11.9-.1-11.6-32.2-11.6-32.2s12.2.5 19.9 18.6zm-111-10.8c-3 6.3 1 11.4 4.4 9.6 5.9-3 8.4-10.9 8.4-10.9s-10.1-4.4-12.8 1.3z"
      />
      <path
        fill="#fff"
        stroke="#5AA2DC"
        d="M172.6 413c-6.4-12.7-13.6-18.8-25.1-18.8-19.4 0-31.9 20.8-34.3 47.6-.2-3.3-3.7-6.7-4-10.2-3.4-46 21.8-64.1 40.7-64.1 15.5 0 19.4 22.2 22.7 45.5z"
      />
      <path
        stroke="#5AA2DC"
        d="M109.3 442.5c-3.5-46 22.9-64.2 40.3-64.2 9.7 0 15.8 5.7 20.4 18.7"
      />
      <path
        fill="#89BDE6"
        stroke="#89BDE6"
        d="M36.6 348c-5.2 5.2-14.6 26.2-3 30.4 11.6 4.2 25.2-37 25.2-37s-9.8-5.6-22.2 6.7z"
      />
      <path
        fill="#D0E4F5"
        d="M132.2 443.6l-4.1 22.4a23.8 23.8 0 01-46.7 0l-4.2-22.4c0-1.1.3-2.2.7-3.2 3.3 3.4 14.1 5.8 27 5.8 12.5 0 23.2-2.4 26.7-5.6.4 1 .6 2 .6 3z"
      />
      <path
        fill="#137ACD"
        d="M129.5 438.3c0 3.2-11 5.7-24.7 5.7-13.6 0-24.7-2.5-24.7-5.7 0-.3 0-.5.2-.8 1.6-2.8 12-5 24.5-5 13 0 23.5 2.4 24.6 5.3v.5z"
      />
      <path
        fill="#fff"
        stroke="#89BDE6"
        d="M113.7 404.8a131 131 0 01-5.1 36.9h-9.4c0-55.8-20.4-101-45.4-101-6.5 0-12.7 3.1-18.3 8.6C52 330 58.8 324.7 68.2 324.7c22.5 0 45.5 35.9 45.5 80.1z"
      />
      <path
        stroke="#89BDE6"
        d="M46 337.6c5.3-4 8.8-5.7 14.9-5.7 25 0 50.5 41.8 43.8 109.8"
      />
      <path
        fill="#fff"
        stroke="#5AA2DC"
        d="M104.8 441.7s1.3-52.4-27.2-52.6c-7.6 0-14.6 12-14.6 12s33.4-8.8 35 40.6h6.8z"
      />
      <path stroke="#5AA2DC" d="M101.3 441.8c.4-14.7-3.4-50.3-32.2-48.4" />
      <path
        fill="#fff"
        stroke="#89BDE6"
        d="M62.8 351.4a2.6 2.6 0 10-2.6-2.6 2.6 2.6 0 002.6 2.6zm62.4 75.7a3.9 3.9 0 100-7.8 3.9 3.9 0 00-3.8 3.9 3.9 3.9 0 003.8 3.9z"
      />
      <path
        fill="#D0E4F5"
        d="M118.8 352.5a7.3 7.3 0 007.3-7.2 7.3 7.3 0 00-7.3-7.3 7.3 7.3 0 00-7.3 7.3 7.3 7.3 0 007.3 7.2z"
      />
      <path
        stroke="#137ACD"
        d="M138 510.9l-6.5-32.2a3 3 0 00-5.6-1c-9 14.8-33.2 15-42.2.2l-.2-.3a3 3 0 00-5.6 1l-6.5 32.2m33.3-21.9V511m-48-.1h215"
      />
    </svg>
  );
};

export const RightColor: React.FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z"
        fill="#FFB74F"
      />
      <path
        d="M47.9983 24.1538L36.8315 12.9869C33.6887 9.67764 29.1053 7.5918 24.0003 7.5918C14.525 7.5918 6.84375 14.7751 6.84375 23.6362C6.84375 28.0237 8.72766 31.9991 11.7794 34.8956L24.867 47.9832C37.6693 47.5285 47.9175 37.048 47.9983 24.1538Z"
        fill="#FE880C"
      />
      <path
        d="M41.1568 23.6362C41.1568 14.7751 33.4756 7.5918 24.0003 7.5918C14.525 7.5918 6.84375 14.7752 6.84375 23.6362C6.84375 32.4972 14.525 39.6805 24.0003 39.6805C26.8202 39.6805 29.4811 39.0442 31.828 37.9168L38.9758 39.6805L36.5454 34.5792C39.4057 31.7128 41.1568 27.8661 41.1568 23.6362Z"
        fill="white"
      />
      <path
        d="M36.5442 34.5788L38.9751 39.68L31.8275 37.917C29.4804 39.044 26.8194 39.68 24 39.68V7.5918C33.4747 7.5918 41.1558 14.7752 41.1558 23.6365C41.1558 27.8663 39.4048 31.7128 36.5442 34.5788Z"
        fill="#FFF5CB"
      />
      <path
        d="M31.2375 15.6133L21.6462 26.1206L16.3049 21.5756L13.0371 25.416L22.0875 33.1167L34.9615 19.0126L31.2375 15.6133Z"
        fill="#00DEC1"
      />
      <path
        d="M34.9609 19.0118L23.998 31.0229V23.5443L31.237 15.6143L34.9609 19.0118Z"
        fill="#00CDB4"
      />
    </svg>
  );
};

export const WritingColor: React.FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="44"
      height="48"
      viewBox="0 0 44 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M35.1337 2.89746H4.51805L4.03516 47.0343L36.5824 46.5514V41.1741L35.9567 35.5643L36.5824 31.445V4.34615C36.5824 3.54609 35.9338 2.89746 35.1337 2.89746Z"
        fill="#CDE2FF"
      />
      <path
        d="M33.6992 45.1027L33.6841 43.654L4.51705 2.89746C3.71699 2.89746 3.06836 3.54609 3.06836 4.34615V46.5514C3.06836 47.3514 3.71699 48.0001 4.51705 48.0001H35.1327C35.9328 48.0001 36.5814 47.3514 36.5814 46.5514H32.2505C33.0507 46.5514 33.6992 45.9028 33.6992 45.1027Z"
        fill="#9EC8FC"
      />
      <path
        d="M36.5809 31.4453L33.6835 23.1171L29.7031 21.4189L36.5809 41.1745V31.4453Z"
        fill="#9EC8FC"
      />
      <path
        d="M32.2353 0H1.61962L1.13672 44.1368L33.684 43.6539V32.8518L32.4472 22.5513L33.684 18.6158V1.44869C33.684 0.648628 33.0354 0 32.2353 0Z"
        fill="#EDF6FF"
      />
      <path
        d="M33.6845 18.6152L30.7189 14.9089C30.3452 14.4372 29.5859 14.7015 29.5859 15.3034V20.7198C29.5859 20.9575 29.6258 21.1934 29.704 21.4179L33.6845 32.8512V18.6152Z"
        fill="#CDE2FF"
      />
      <path
        d="M27.8901 40.0327H5.96653C5.5665 40.0327 5.24219 39.7084 5.24219 39.3083C5.24219 38.9083 5.5665 38.584 5.96653 38.584H27.8901C28.2901 38.584 28.6144 38.9083 28.6144 39.3083C28.6144 39.7084 28.2901 40.0327 27.8901 40.0327Z"
        fill="#7E8B96"
      />
      <path
        d="M27.8901 35.686H5.96653C5.5665 35.686 5.24219 35.3617 5.24219 34.9616C5.24219 34.5616 5.5665 34.2373 5.96653 34.2373H27.8901C28.2901 34.2373 28.6144 34.5616 28.6144 34.9616C28.6144 35.3617 28.2901 35.686 27.8901 35.686Z"
        fill="#7E8B96"
      />
      <path
        d="M27.8901 31.3403H5.96653C5.5665 31.3403 5.24219 31.016 5.24219 30.6159C5.24219 30.2159 5.5665 29.8916 5.96653 29.8916H27.8901C28.2901 29.8916 28.6144 30.2159 28.6144 30.6159C28.6144 31.016 28.2901 31.3403 27.8901 31.3403Z"
        fill="#7E8B96"
      />
      <path
        d="M25.9585 26.9946H5.96653C5.5665 26.9946 5.24219 26.6703 5.24219 26.2702C5.24219 25.8702 5.5665 25.5459 5.96653 25.5459H25.9585C26.3585 25.5459 26.6828 25.8702 26.6828 26.2702C26.6828 26.6703 26.3585 26.9946 25.9585 26.9946Z"
        fill="#7E8B96"
      />
      <path
        d="M27.8901 22.6479H5.96653C5.5665 22.6479 5.24219 22.3236 5.24219 21.9236C5.24219 21.5235 5.5665 21.1992 5.96653 21.1992H27.8901C28.2901 21.1992 28.6144 21.5235 28.6144 21.9236C28.6144 22.3236 28.2901 22.6479 27.8901 22.6479Z"
        fill="#7E8B96"
      />
      <path
        d="M27.8901 18.3012H5.96653C5.5665 18.3012 5.24219 17.9769 5.24219 17.5769C5.24219 17.1769 5.5665 16.8525 5.96653 16.8525H27.8901C28.2901 16.8525 28.6144 17.1769 28.6144 17.5769C28.6144 17.9769 28.2901 18.3012 27.8901 18.3012Z"
        fill="#7E8B96"
      />
      <path
        d="M5.96654 13.956C5.56757 13.956 5.24354 13.6333 5.24219 13.234C5.24084 12.834 5.56409 12.5086 5.96412 12.5073L20.3545 12.459C20.7574 12.4573 21.0799 12.7809 21.0812 13.1809C21.0826 13.581 20.7593 13.9063 20.3593 13.9077L5.96895 13.956C5.96818 13.956 5.96731 13.956 5.96654 13.956Z"
        fill="#7E8B96"
      />
      <path
        d="M24.0719 6.71237H9.78294C9.38291 6.71237 9.05859 6.38805 9.05859 5.98802C9.05859 5.58799 9.38291 5.26367 9.78294 5.26367H24.0719C24.4719 5.26367 24.7962 5.58799 24.7962 5.98802C24.7962 6.38805 24.4719 6.71237 24.0719 6.71237Z"
        fill="#7E8B96"
      />
      <path
        d="M1.62057 42.2052V0C0.820503 0 0.171875 0.648628 0.171875 1.44869V43.6539C0.171875 44.454 0.820503 45.1026 1.62057 45.1026H32.2363C33.0363 45.1026 33.685 44.454 33.685 43.6539H3.06926C2.26919 43.6539 1.62057 43.0053 1.62057 42.2052Z"
        fill="#CDE2FF"
      />
      <path
        d="M32.1684 13.4609L31.6855 15.2605L32.1684 17.362L34.1634 15.9788L32.1684 13.4609Z"
        fill="#7E8B96"
      />
      <path
        d="M31.0352 13.8551V17.0674L32.1681 17.3617V13.4607C31.7943 12.989 31.0352 13.2532 31.0352 13.8551Z"
        fill="#5F6C75"
      />
      <path
        d="M34.1641 15.9785L32.1692 16.6664L31.3652 18.9915C31.3724 19.3581 32.6497 20.1699 32.6497 20.1699L35.874 18.3266C35.7958 18.1021 35.6805 17.8924 35.5329 17.7061L34.1641 15.9785Z"
        fill="#E0BBA4"
      />
      <path
        d="M32.4248 19.5266C32.3272 19.2462 32.1753 18.8534 32.1681 18.4868V16.666L31.0352 17.0671V19.2712C31.0352 19.5089 31.075 19.7449 31.1532 19.9693L32.6486 20.1695L32.4248 19.5266Z"
        fill="#D8AB8C"
      />
      <path
        d="M32.4238 19.5266L39.7229 42.4466C39.8828 42.9056 40.6224 42.905 41.674 42.5389C43.2332 41.9961 43.7778 41.0349 43.7778 41.0349L35.8718 18.3262L32.4238 19.5266Z"
        fill="#FFD064"
      />
      <path
        d="M40.2206 41.8771L32.4239 19.5273L31.1523 19.9701L39.0583 42.6788C39.3184 43.4259 40.5859 43.6639 41.8892 43.2102C43.1924 42.7564 44.0381 41.7829 43.778 41.0357C43.778 41.0357 43.3287 41.4357 42.2772 41.8018C41.2254 42.168 40.3803 42.336 40.2206 41.8771Z"
        fill="#EBB044"
      />
    </svg>
  );
};

export const CrossColor: React.FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="46"
      height="46"
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M23 0.5C18.5499 0.5 14.1998 1.8196 10.4997 4.29193C6.79957 6.76427 3.91569 10.2783 2.21272 14.3896C0.509749 18.501 0.0641738 23.025 0.932341 27.3895C1.80051 31.7541 3.94343 35.7632 7.09011 38.9099C10.2368 42.0566 14.2459 44.1995 18.6105 45.0677C22.9751 45.9358 27.4991 45.4903 31.6104 43.7873C35.7217 42.0843 39.2357 39.2004 41.7081 35.5003C44.1804 31.8002 45.5 27.4501 45.5 23C45.5 17.0326 43.1295 11.3097 38.9099 7.0901C34.6903 2.87053 28.9674 0.5 23 0.5ZM32.54 30.5L30.5 32.54L23 25.115L15.575 32.54L13.46 30.5L20.885 23L13.46 15.575L15.575 13.46L23 20.885L30.5 13.46L32.615 15.575L25.115 23L32.54 30.5Z"
        fill="#EA2D3F"
      />
    </svg>
  );
};

export const CheckedWritingColor: React.FC<SVGProps<SVGSVGElement>> = (
  props,
) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.47397 38.3552C5.25262 38.5648 4.89778 38.5348 4.71609 38.29C1.75294 34.2979 0 29.3536 0 24C0 10.7524 10.7334 0.0117281 23.9783 9.38843e-06C37.2043 -0.0116156 48 10.774 48 24C48 30.6581 45.2887 36.6831 40.91 41.0308C36.518 35.4013 29.6699 31.7813 21.9765 31.7813C15.584 31.7813 9.77522 34.2805 5.47397 38.3552Z"
        fill="#55A4F9"
      />
      <path
        d="M42.187 4.21875V34.7073C40.3396 36.851 38.1196 38.6646 35.6275 40.0474H12.3715C11.6416 39.6424 10.9351 39.2003 10.2544 38.724C10.2528 38.6966 10.252 38.669 10.252 38.6411V4.21875C10.252 3.44212 10.8816 2.8125 11.6582 2.8125H40.7808C41.5574 2.8125 42.187 3.44212 42.187 4.21875Z"
        fill="#6A61B4"
      />
      <path
        d="M13.3609 38.7239C14.0416 39.2003 14.7482 39.6423 15.478 40.0473H12.3735C11.6436 39.6423 10.9371 39.2002 10.2563 38.7239C10.2548 38.6965 10.2539 38.6689 10.2539 38.641V4.21875C10.2539 3.44212 10.8835 2.8125 11.6602 2.8125H14.7647C13.9881 2.8125 13.3584 3.44212 13.3584 4.21875V38.641C13.3584 38.6689 13.3593 38.6964 13.3609 38.7239Z"
        fill="#5F55AF"
      />
      <path
        d="M36.6226 8.90625V44.4164C32.9556 46.6883 28.631 48 24 48C16.0815 48 9.05878 44.1652 4.6875 38.2513V8.90625C4.6875 8.12962 5.31712 7.5 6.09375 7.5H35.2163C35.993 7.5 36.6226 8.12962 36.6226 8.90625Z"
        fill="#E9F3FE"
      />
      <path
        d="M8.90625 7.5C8.12962 7.5 7.5 8.12962 7.5 8.90625V41.4284C6.47231 40.4551 5.53059 39.3919 4.6875 38.2513V8.90625C4.6875 8.12962 5.31712 7.5 6.09375 7.5H8.90625Z"
        fill="#C8E2FD"
      />
      <path
        d="M17.9688 12.8906C17.9688 13.2789 17.654 13.5938 17.2657 13.5938H10.0781C9.68981 13.5938 9.375 13.2789 9.375 12.8906C9.375 12.5023 9.68981 12.1875 10.0781 12.1875H17.2657C17.654 12.1875 17.9688 12.5023 17.9688 12.8906Z"
        fill="#1380E2"
      />
      <path
        d="M15.9375 39.1406C15.9375 39.5289 15.6227 39.8438 15.2344 39.8438H10.0781C9.68981 39.8438 9.375 39.5289 9.375 39.1406C9.375 38.7523 9.68981 38.4375 10.0781 38.4375H15.2344C15.6227 38.4375 15.9375 38.7523 15.9375 39.1406Z"
        fill="#76B6FA"
      />
      <path
        d="M9.375 15.7031C9.375 15.3148 9.68981 15 10.0781 15H12.4219C12.8102 15 13.125 15.3148 13.125 15.7031C13.125 16.0914 12.8102 16.4062 12.4219 16.4062H10.0781C9.68981 16.4062 9.375 16.0914 9.375 15.7031ZM12.4219 35.625H10.0781C9.68981 35.625 9.375 35.9398 9.375 36.3281C9.375 36.7164 9.68981 37.0312 10.0781 37.0312H12.4219C12.8102 37.0312 13.125 36.7164 13.125 36.3281C13.125 35.9398 12.8102 35.625 12.4219 35.625Z"
        fill="#55A4F9"
      />
      <path
        d="M9.375 19.9219C9.375 19.5336 9.68981 19.2188 10.0781 19.2188H17.2657C17.654 19.2188 17.9688 19.5336 17.9688 19.9219C17.9688 20.3102 17.654 20.625 17.2657 20.625H10.0781C9.68981 20.625 9.375 20.3102 9.375 19.9219ZM17.2657 30.4688H10.0781C9.68981 30.4688 9.375 30.7836 9.375 31.1719C9.375 31.5602 9.68981 31.875 10.0781 31.875H17.2657C17.654 31.875 17.9688 31.5602 17.9688 31.1719C17.9688 30.7836 17.654 30.4688 17.2657 30.4688ZM30.7031 13.5938H33.0469C33.4352 13.5938 33.75 13.2789 33.75 12.8906C33.75 12.5023 33.4352 12.1875 33.0469 12.1875H30.7031C30.3148 12.1875 30 12.5023 30 12.8906C30 13.2789 30.3148 13.5938 30.7031 13.5938ZM33.0469 19.4531H28.8281C28.4398 19.4531 28.125 19.7679 28.125 20.1562C28.125 20.5446 28.4398 20.8594 28.8281 20.8594H33.0469C33.4352 20.8594 33.75 20.5446 33.75 20.1562C33.75 19.7679 33.4352 19.4531 33.0469 19.4531ZM33.0469 22.2656H30.7031C30.3148 22.2656 30 22.5804 30 22.9688C30 23.3571 30.3148 23.6719 30.7031 23.6719H33.0469C33.4352 23.6719 33.75 23.3571 33.75 22.9688C33.75 22.5804 33.4352 22.2656 33.0469 22.2656ZM22.7344 27.4219H10.0781C9.68981 27.4219 9.375 27.7367 9.375 28.125C9.375 28.5133 9.68981 28.8281 10.0781 28.8281H22.7344C23.1227 28.8281 23.4375 28.5133 23.4375 28.125C23.4375 27.7367 23.1227 27.4219 22.7344 27.4219ZM22.7344 22.2656H10.0781C9.68981 22.2656 9.375 22.5804 9.375 22.9688C9.375 23.3571 9.68981 23.6719 10.0781 23.6719H22.7344C23.1227 23.6719 23.4375 23.3571 23.4375 22.9688C23.4375 22.5804 23.1227 22.2656 22.7344 22.2656Z"
        fill="#A7D0FC"
      />
      <path
        d="M46.8751 23.4835C46.8317 23.7431 46.7638 23.9945 46.6741 24.2352C46.3709 24.1486 46.0364 24.2749 45.8716 24.5603C45.707 24.8454 45.7646 25.1979 45.9907 25.417C45.825 25.6173 45.6407 25.8016 45.4405 25.9673C45.2212 25.7412 44.8688 25.6836 44.5837 25.8482C44.2983 26.013 44.172 26.3475 44.2587 26.6506C44.0179 26.7403 43.7666 26.8082 43.5069 26.8516C43.4302 26.546 43.1536 26.3196 42.8243 26.3196C42.4948 26.3196 42.2183 26.5459 42.1417 26.8516C41.882 26.8082 41.6307 26.7403 41.3899 26.6506C41.4765 26.3474 41.3502 26.0129 41.0649 25.8482C40.7798 25.6836 40.4273 25.7411 40.2081 25.9673C40.0078 25.8016 39.8235 25.6173 39.6579 25.417C39.8839 25.1978 39.9416 24.8454 39.7769 24.5603C39.6121 24.2748 39.2776 24.1485 38.9744 24.2352C38.8847 23.9945 38.8168 23.7431 38.7734 23.4835C39.0791 23.4068 39.3055 23.1302 39.3055 22.8009C39.3055 22.4714 39.0792 22.1949 38.7734 22.1183C38.8168 21.8586 38.8847 21.6072 38.9744 21.3665C39.2776 21.4531 39.6121 21.3268 39.7769 21.0414C39.9416 20.7563 39.8839 20.4038 39.6579 20.1847C39.8235 19.9844 40.0078 19.8001 40.2081 19.6344C40.4274 19.8605 40.7798 19.9181 41.0649 19.7535C41.3503 19.5887 41.4766 19.2542 41.3899 18.951C41.6307 18.8613 41.882 18.7934 42.1417 18.75C42.2184 19.0556 42.4949 19.282 42.8243 19.282C43.1537 19.282 43.4303 19.0556 43.5069 18.75C43.7666 18.7934 44.0179 18.8613 44.2587 18.951C44.172 19.2541 44.2983 19.5887 44.5837 19.7535C44.8689 19.9181 45.2213 19.8605 45.4406 19.6344C45.6408 19.8001 45.8251 19.9844 45.9908 20.1847C45.7648 20.4039 45.7071 20.7563 45.8717 21.0415C46.0365 21.3269 46.371 21.4533 46.6742 21.3666C46.7639 21.6073 46.8318 21.8587 46.8752 22.1184C46.5696 22.195 46.3432 22.4716 46.3432 22.8009C46.3431 23.1302 46.5695 23.4068 46.8751 23.4835Z"
        fill="#FFF04A"
      />
      <path
        d="M44.7791 22.8007C44.7791 23.8804 43.9038 24.7556 42.8241 24.7556C41.7444 24.7556 40.8691 23.8804 40.8691 22.8007C40.8691 21.721 41.7444 20.8457 42.8241 20.8457C43.9038 20.8457 44.7791 21.721 44.7791 22.8007Z"
        fill="#3493F8"
      />
      <path
        d="M43.4773 38.1775C43.3703 38.9503 43.1689 39.693 42.8849 40.3933L43.082 40.5071C43.7007 40.8644 43.9128 41.6557 43.5555 42.2744C43.1982 42.8932 42.407 43.1052 41.7882 42.7479L41.5894 42.6331C41.1173 43.2375 40.5725 43.7823 39.9681 44.2544L40.0829 44.4533C40.4402 45.072 40.2281 45.8633 39.6094 46.2205C38.9906 46.5778 38.1994 46.3658 37.8421 45.747L37.7283 45.5499C37.0279 45.8339 36.2853 46.0354 35.5125 46.1424V46.3713C35.5125 47.0858 34.9333 47.665 34.2188 47.665C33.5042 47.665 32.925 47.0858 32.925 46.3713V46.1424C32.1522 46.0354 31.4096 45.8339 30.7092 45.5499L30.5954 45.747C30.2381 46.3658 29.4469 46.5778 28.8281 46.2205C28.2094 45.8633 27.9973 45.072 28.3546 44.4533L28.4694 44.2544C27.865 43.7823 27.3203 43.2375 26.8481 42.6331L26.6493 42.7479C26.0305 43.1052 25.2393 42.8932 24.882 42.2744C24.5247 41.6556 24.7368 40.8643 25.3555 40.5071L25.5526 40.3933C25.2687 39.6929 25.0672 38.9503 24.9602 38.1775H24.7312C24.0167 38.1775 23.4375 37.5984 23.4375 36.8838C23.4375 36.1692 24.0167 35.59 24.7312 35.59H24.9602C25.0672 34.8173 25.2686 34.0746 25.5526 33.3743L25.3555 33.2604C24.7368 32.9032 24.5247 32.1119 24.882 31.4932C25.2393 30.8743 26.0305 30.6624 26.6493 31.0196L26.8481 31.1345C27.3203 30.5301 27.865 29.9853 28.4694 29.5132L28.3546 29.3143C27.9973 28.6956 28.2094 27.9043 28.8281 27.547C29.4469 27.1898 30.2381 27.4018 30.5954 28.0206L30.7092 28.2176C31.4096 27.9337 32.1522 27.7323 32.925 27.6252V27.3963C32.925 26.6817 33.5042 26.1025 34.2188 26.1025C34.9333 26.1025 35.5125 26.6817 35.5125 27.3963V27.6252C36.2853 27.7322 37.0279 27.9337 37.7283 28.2176L37.8421 28.0206C38.1994 27.4018 38.9906 27.1898 39.6094 27.547C40.2281 27.9043 40.4402 28.6956 40.0829 29.3143L39.9681 29.5132C40.5725 29.9853 41.1173 30.5301 41.5894 31.1345L41.7882 31.0196C42.407 30.6624 43.1982 30.8744 43.5555 31.4932C43.9128 32.1119 43.7007 32.9032 43.082 33.2604L42.8849 33.3743C43.1688 34.0747 43.3703 34.8173 43.4773 35.59H43.7063C44.4208 35.59 45 36.1692 45 36.8838C45 37.5984 44.4208 38.1775 43.7063 38.1775H43.4773Z"
        fill="#E9CC5A"
      />
      <path
        d="M39.814 36.8836C39.814 39.975 37.308 42.481 34.2166 42.481C31.1252 42.481 28.6191 39.975 28.6191 36.8836C28.6191 33.7922 31.1252 31.2861 34.2166 31.2861C37.308 31.2861 39.814 33.7922 39.814 36.8836Z"
        fill="#E9F3FE"
      />
      <path
        d="M34.2166 30.583C30.7424 30.583 27.916 33.4094 27.916 36.8836C27.916 40.3578 30.7424 43.1841 34.2166 43.1841C37.6908 43.1841 40.5171 40.3578 40.5171 36.8836C40.5171 33.4094 37.6908 30.583 34.2166 30.583ZM34.2166 41.7779C31.5178 41.7779 29.3223 39.5823 29.3223 36.8836C29.3223 34.1849 31.5178 31.9893 34.2166 31.9893C36.9154 31.9893 39.1109 34.1849 39.1109 36.8836C39.1109 39.5823 36.9154 41.7779 34.2166 41.7779Z"
        fill="#E1B91E"
      />
      <path
        d="M40.3722 33.9122L34.7472 39.5372C34.6099 39.6745 34.4299 39.7431 34.25 39.7431C34.0701 39.7431 33.8901 39.6745 33.7529 39.5372L31.2528 37.0372C30.9782 36.7625 30.9782 36.3174 31.2528 36.0428C31.5274 35.7683 31.9726 35.7683 32.2471 36.0428L34.25 38.0456L39.3779 32.9178C39.6525 32.6433 40.0977 32.6433 40.3722 32.9178C40.6468 33.1924 40.6468 33.6375 40.3722 33.9122Z"
        fill="#EA552D"
      />
    </svg>
  );
};
